import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const importcontainerApi = createApi({
  reducerPath: "importcontainerApi",
  baseQuery,
  tagTypes: ["Container"],
  endpoints: (builder) => ({
    // GET by importerMasterId
    getContainerByMasterId: builder.query({
      query: (importerMasterId) => {
        return `/import/container/${importerMasterId}`;
      },
      transformResponse: (response) => {
        const data = response?.data ?? [];
        return data;
      },
      providesTags: ["Container"],
    }),

    // GET by importerMasterId + importContainerId
    getContainerById: builder.query({
      query: ({ importerMasterId, importContainerId }) => {
        return `/import/container/${importerMasterId}/${importContainerId}`;
      },
      transformResponse: (response) => {
        const data = response?.data ?? {};
        return data;
      },
      providesTags: ["Container"],
    }),

    // CREATE
    createContainer: builder.mutation({
      query: ({ importerMasterId, importContainer }) => {

        return {
          url: `/import/container/${importerMasterId}`,
          method: "PUT",
          body: { importContainer },
        };
      },
      transformResponse: (response) => {
        return response;
      },
      invalidatesTags: ["Container"],
    }),

    // UPDATE
    updateContainer: builder.mutation({
      query: ({ importerMasterId, importContainerId, importContainer }) => {
      
        return {
          url: `/import/container/${importerMasterId}/${importContainerId}`,
          method: "PUT",
          body: { importContainer },
        };
      },
      transformResponse: (response) => {
        return response;
      },
      invalidatesTags: ["Container"],
    }),

    // DELETE
    deleteContainer: builder.mutation({
      query: ({ importContainerId }) => {
        return {
          url: `/import/container/${importContainerId}`,
          method: "DELETE",
        };
      },
      transformResponse: (response) => {
        return response;
      },
      invalidatesTags: ["Container"],
    }),
  }),
});

export const {
  useGetContainerByMasterIdQuery,
  useGetContainerByIdQuery,
  useCreateContainerMutation,
  useUpdateContainerMutation,
  useDeleteContainerMutation,
} = importcontainerApi;
